import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingAdvantages8 = props => (
    <section id="outsourcing-advantages-section8" className="my pt-5 blue-bg">
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingAdvantages:section-8.title')}</h2>
            <p className='m-0'><Trans i18nKey="services:outsourcingAdvantages:section-8.text" components={{ br: <br /> }} /></p>
        </Container>
    </section>
);

export default OutsourcingAdvantages8;
